import { clearStaffSession, getStaffSessionToken } from '../staffSession';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../store/state';

type AuthState = {
  token: string | null;
  isAdmin: boolean;
};

// Hydrate synchronously from storage so a hard page load (e.g. typing
// /callum or refreshing /admin/select-user) doesn't briefly look logged-out
// and bounce admins back through team-login.
export const initialState: AuthState = {
  token: localStorage.getItem('token'),
  isAdmin: sessionStorage.getItem('isAdmin') === 'true' && Boolean(getStaffSessionToken())
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('token', action.payload);
    },
    setAdminMode: (state, action) => {
      state.isAdmin = action.payload;
      if (action.payload) {
        sessionStorage.setItem('isAdmin', 'true');
      } else {
        sessionStorage.removeItem('isAdmin');
      }
    },
    clearToken: (state) => {
      state.token = null;
      state.isAdmin = false;
      localStorage.removeItem('token');
      sessionStorage.removeItem('isAdmin');
      clearStaffSession();
    }
  }
});

// Actions generated from the slice
export const { setAuthToken, setAdminMode, clearToken } = authSlice.actions;

// export user selector to get the slice in any component
export const authSelector = (state: RootState) => state.auth;
// export The reducer
const authReducer = authSlice.reducer;
export default authReducer;
